import { render, staticRenderFns } from "./RewardColumn.vue?vue&type=template&id=5c150a36&scoped=true&"
import script from "./RewardColumn.vue?vue&type=script&lang=js&"
export * from "./RewardColumn.vue?vue&type=script&lang=js&"
import style0 from "./RewardColumn.vue?vue&type=style&index=0&id=5c150a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c150a36",
  null
  
)

export default component.exports